import React, { useState, useRef } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import ja from 'date-fns/locale/ja';
import { Placement } from '@popperjs/core';
import DatepickerInput from './DatepickerInput';
import TodayButton from './TodayButton';

interface ActDatepickerProps {
  defaultSelected?: Date | null | undefined;
  value?: string | undefined;
  onChange(date: Date): void;
  onSelect?(date: Date): void;
  disabled?: boolean | undefined;
  onTodayButtonClick?: () => void;
  isClearable?: boolean | undefined;
  placeholder?: string;
  popperPlacement?: Placement;
  minDate?: Date;
  maxDate?: Date;
  preventOpenOnFocus?: boolean;
}

const ActDatepicker: React.FC<ActDatepickerProps> = ({
  value,
  popperPlacement = 'auto-start',
  onChange,
  disabled,
  onTodayButtonClick,
  defaultSelected,
  isClearable,
  placeholder,
  onSelect,
  minDate,
  maxDate,
  preventOpenOnFocus,
}) => {
  const [datePickerDate, setDatePickerDate] = useState(defaultSelected);
  const datepickerRef = useRef<React.ElementRef<typeof DatePicker>>(null);

  registerLocale('ja', ja);

  return (
    <div className={'uc-icon-textbox uc-icon-textbox--ws'}>
      <DatePicker
        ref={datepickerRef}
        className={'uc-textbox'}
        placeholderText={placeholder ? placeholder : '年/月/日'}
        dateFormat={'yyyy/MM/dd'}
        popperPlacement={popperPlacement}
        isClearable={isClearable}
        value={value}
        selected={value ? new Date(value) : datePickerDate ? datePickerDate : defaultSelected}
        locale={'ja'}
        customInput={<DatepickerInput />}
        onSelect={(data) => {
          if (onSelect) {
            onSelect(data);
          }
        }}
        onChange={(dt: Date) => {
          setDatePickerDate(dt);
          onChange(dt);
        }}
        todayButton={
          onTodayButtonClick && (
            <TodayButton
              disabled={disabled}
              onTodayButtonClick={onTodayButtonClick}
              defaultSelected={defaultSelected}
              setDatePickerDate={setDatePickerDate}
              datepickerRef={datepickerRef}
            />
          )
        }
        clearButtonTitle={'クリア'}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        preventOpenOnFocus={preventOpenOnFocus}
      />
    </div>
  );
};

export default ActDatepicker;
